import { Search } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useGlobalSearch } from '../../contexts/GlobalSearchContext';

interface SearchTriggerProps {
  compact?: boolean;
}

export function SearchTrigger({ compact = false }: SearchTriggerProps) {
  const { openSearch } = useGlobalSearch();
  const isMac = typeof navigator !== 'undefined' && navigator.platform.toUpperCase().includes('MAC');
  const shortcut = isMac ? '⌘K' : 'Ctrl K';

  return (
    <Box
      onClick={openSearch}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openSearch();
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: compact ? 1 : 1.25,
        width: '100%',
        px: compact ? 1.25 : 1.75,
        py: compact ? 0.375 : 0.75,
        minHeight: compact ? 32 : 40,
        maxHeight: compact ? 32 : 40,
        borderRadius: compact ? '8px' : '10px',
        bgcolor: '#232323',
        border: '1px solid #3a3a3a',
        cursor: 'pointer',
        transition: 'border-color 0.2s, background-color 0.2s',
        '&:hover': { bgcolor: '#2a2a2a', borderColor: '#555' },
        '&:focus-visible': { outline: '2px solid #666', outlineOffset: 2 },
      }}
    >
      <Search sx={{ color: '#888', fontSize: compact ? 16 : 20, flexShrink: 0 }} />
      <Typography
        sx={{
          flex: 1,
          fontSize: compact ? 12 : 14,
          color: '#888',
          userSelect: 'none',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        Search pages, phone, email, booking ID…
      </Typography>
      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          alignItems: 'center',
          gap: 0.4,
          px: compact ? 0.6 : 0.85,
          py: compact ? 0.25 : 0.35,
          borderRadius: compact ? '4px' : '6px',
          border: '1px solid #444',
          bgcolor: '#1c1c1c',
          flexShrink: 0,
        }}
      >
        <Typography sx={{ fontSize: compact ? 10 : 11, fontWeight: 700, color: '#999', lineHeight: 1 }}>
          {shortcut}
        </Typography>
      </Box>
    </Box>
  );
}
